type ProgressBarProps = {
    totalCount: number;
    completedCount: number;
    className?: string;
    height?: number;
    showPercentageProgress?: boolean;
    showCountProgress?: boolean;
};

const ProgressBar = ({
    totalCount,
    completedCount,
    className,
    height = 6,
    showPercentageProgress = true,
    showCountProgress = true }: ProgressBarProps) => {
    const completedPercentage = Math.round((completedCount / totalCount) * 100);
    const clampedValue = Math.min(100, Math.max(0, completedPercentage));

    return (
        <div className="w-100">
            <div className="d-flex flex-row align-items-center gap-3">
                <div className="w-100">
                    <div
                        className={`progress ${className ?? ""}`.trim()}
                        role="progressbar"
                        aria-valuenow={clampedValue}
                        aria-valuemin={0}
                        aria-valuemax={100}
                        aria-label="Simulation setup progress"
                        style={{ height }}
                    >
                        <div className="progress-container">
                            <div className="progress-bar" style={{ width: `${clampedValue}%` }}></div>
                        </div>
                    </div>
                </div>
                {showCountProgress && (
                    <span className="fs-8 fw-semibold text-secondary text-nowrap">
                        {completedCount}
                        {" of "}
                        {totalCount}
                        {" "}
                        inputs selected
                    </span>
                )}
            </div>
            {showPercentageProgress && (
                <span className="fs-8 fw-normal k-text-subtle">
                    {completedPercentage}
                    % Complete
                </span>
            )}
        </div>
    );
};

export default ProgressBar;
